import React from "react";
import {
    Box,
    List,
    ListItem,
    ListItemText,
    Paper,
    Typography,
    useTheme,
    IconButton,
    Divider,
    useMediaQuery,
} from "@mui/material";
import { tokens } from "../layout/theme";
import GetAppIcon from "@mui/icons-material/GetApp";
import { c3GuideFiles } from "../../data/download-lists";
import { downloadAuthenticatedFile } from "../../api/tasks";
import { BASE_URL } from "../../api";


const C3Guide: React.FC = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Paper elevation={5}>
            <Box
                display="flex"
                flexDirection="column"
                bgcolor={colors.primary[400]}
                borderRadius="5px"
                marginTop="20px"
            >
                <Box
                    mx="20px"
                    mt="40px"
                    mb="10px"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        minHeight: "93vh",
                    }}
                >
                    <Typography variant="h4" gutterBottom sx={{ mb: "2px" }}>
                        c3 Anleitungen
                    </Typography>
                    <List>
                        {c3GuideFiles.map((file, fileIndex) => (
                            <React.Fragment key={`file-${fileIndex}`}>

                                <ListItem
                                    button
                                    onClick={() => downloadAuthenticatedFile(`${BASE_URL}/secure-downloads/${encodeURIComponent(file?.fileUrl || '')}`, {}, file.germanTitle)}
                                    sx={{
                                        listStyle: "outside",
                                        textDecoration: "none",
                                        width: "fit-content",
                                    }}
                                >
                                    <ListItemText
                                        style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: isSmallScreen
                                                ? "normal"
                                                : "nowrap", // Allow text to wrap normally on small screens
                                            wordBreak: isSmallScreen
                                                ? "break-word"
                                                : "normal", // Break long words if needed
                                            maxWidth: isSmallScreen ? "200px" : "none", // Limit width on small screens
                                        }}
                                        sx={{
                                            flex: "none",
                                            color:
                                                theme.palette.mode === "dark"
                                                    ? "white"
                                                    : "black",
                                        }}
                                        primary={file.germanTitle}
                                    />
                                    <IconButton edge="end">
                                        <GetAppIcon />
                                    </IconButton>
                                </ListItem>

                                <Divider orientation="horizontal" variant="middle" />
                            </React.Fragment>
                        ))}
                    </List>
                </Box>
            </Box>
        </Paper>
    );
};

export default C3Guide;
